import(/* webpackMode: "eager" */ "/app/apps/tagea-web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/apps/tagea-web/src/app/indigo-pink.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@splidejs/splide/dist/css/splide-core.min.css");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/lib/assets/styles/_main.scss");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/src/lib/assets/icons/linearicons/style.css");
;
import(/* webpackMode: "eager" */ "/app/libs/shared/ui/theming/src/lib/index.css");
;
import(/* webpackMode: "eager" */ "/app/apps/tagea-web/src/libs/features/toaster/toaster.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
